import { SET_RENDERING_RULE } from '../../constants/appTypes';
import { IImageryRenderingRule } from '../../types/layers';

const initialState: IImageryRenderingRule = {
  sentinel: 'Natural Color with DRA',
  landsat: 'Natural Color with DRA'
};

interface imageRenderingRuleAction {
  layerID: string;
  renderingRule: string;
  type: string;
}

export function imageRenderingRule(state = initialState, action: imageRenderingRuleAction) {
  switch (action.type) {
    case SET_RENDERING_RULE:
      const updatedState = {
        ...state,
        [action.layerID]: action.renderingRule
      };
      return updatedState;
    default:
      return state;
  }
}

export default imageRenderingRule;